<template>
    <div class=" bg-white px-4 sm:px-6 md:px-10 lg:px-12 py-3 rounded-xl">
        <div class=" mt-6">
            <b class=" mb-2">Dispatch Request Details</b>
            <div class=" flex items-center  py-1 text-gray-500">
                <span class=" block w-6/12">Dispatch ID: {{ $route?.query?.disptchRef }}</span>
                <span class="block w-6/12">Item Count: {{ getTotalPackages() }} | {{ getLoadWeight() }}kg</span>
            </div>
            <p class="text-gray-500">
                {{ shipping?.shipmentReceiever?.length || 0 }} Receivers, {{ getTotalPackages() }} Packages
            </p>
        </div>

        <div>
            <div class="flex py-24 bg-gray-200 flex-wrap mt-3 w-full h-full z-10 rounded-xl" v-if="!liveTripData.id">
                <div class="w-full flex justify-center">
                    <span class="loader">
                        <img src="@/assets/images/ondemand/loader.svg" /></span>
                </div>
                <p class="w-full text-center pt-4 px-3">
                    {{ loadingMsg }}<br />
                    Please be patient.
                </p>
            </div>
            <div v-else class="mt-3 rounded-2xl overflow-hidden">
                <GmapMap :center="center" :zoom="14" style="width:100%; height:400px">
                    <gmap-polyline :path="polyLines" :options="polyOptions" />
                    <gmap-marker :position="origin" label="🚖" />
                    <gmap-marker :position="destination" :label="distinationLabel" />
                </GmapMap>
            </div>
        </div>

        <div>
            <div v-if="liveTripData.id"
                class=" bg-gray-100 mt-4 rounded p-3 flex flex-wrap justify-between items-center">
                <div class="confirmation_detail">
                    <div class="detail_item">
                        <div class="detail_text">
                            <span class="block w-6/12 text-gray-500">Description</span>
                            <span class="w-6/12 flex items-center justify-end">{{ getPackageDescriptions() }}</span>
                        </div>
                    </div>
                    <div class="detail_item">
                        <div class="detail_text">
                            <span class="block w-6/12 text-gray-500">Receiver(s)</span>
                            <span class="w-6/12 flex items-center justify-end text-right">{{ getRecipientNames() }}</span>
                        </div>
                    </div>
                    <div class="detail_item">
                        <div class="detail_text">
                            <span class="block w-6/12 text-gray-500">Sender</span>
                            <span class="w-6/12 flex items-center justify-end">{{ liveTripData?.origin?.user?.name
                            }}</span>
                        </div>
                    </div>
                    <div class="detail_item">
                        <div class="detail_text">
                            <span class="block w-6/12 text-gray-500">Pick-Up Time</span>
                            <span class="w-6/12 flex items-center justify-end">
                            </span>
                        </div>
                    </div>
                    <div class="detail_item">
                        <div class="detail_text">
                            <span class="block w-6/12 text-gray-500">Estimated Drop-Off</span>
                            <span class="w-6/12 flex items-center justify-end">{{ getDriverETA }}</span>
                        </div>
                    </div>

                </div>
                <span class="verical_divider"></span>
                <div class="confirmation_detail">
                    <div class="detail_item">
                        <div class="detail_text">
                            <span class="block w-6/12 text-gray-500">Payment</span>
                            <span class="w-6/12 flex items-center justify-end capitalize">{{ liveTripData?.paymentType
                            }}</span>
                        </div>
                    </div>
                    <div class="detail_item">
                        <div class="detail_text">
                            <span class="block w-6/12 text-gray-500">Dispatcher</span>
                            <span class="w-6/12 flex items-center justify-end">{{ liveTripData?.driver?.firstname }} {{
                                liveTripData?.driver?.lastname }}</span>
                        </div>
                    </div>
                    <div class="detail_item">
                        <div class="detail_text">
                            <span class="block w-6/12 text-gray-500">Phone Number</span>
                            <span class="w-6/12 flex items-center justify-end">{{ liveTripData?.driver?.mobile_no
                            }}</span>
                        </div>
                    </div>
                    <div class="detail_item">
                        <div class="detail_text">
                            <span class="block w-6/12 text-gray-500">Fleet</span>
                            <span class="w-6/12 flex items-center justify-end">{{
                                liveTripData?.driver?.fleet?.vehicleType }} - {{
                                    liveTripData?.driver?.fleet?.vehicleModel }} - {{
                                    liveTripData?.driver?.fleet?.vehicleNumber }}</span>
                        </div>
                    </div>
                    <div class="detail_item">
                        <div class="detail_text">
                            <span class="block w-6/12 text-gray-500">Status</span>
                            <span class="w-6/12 flex items-center justify-end capitalize" :class="[
                                true ? statusBg(liveTripData ? liveTripData.status : null) : null,
                            ]">{{ liveTripData.status
                                ||
                                liveTripData.status
                                ? liveTripData.status || liveTripData.status
                                : "N/A" }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import moment from "moment";
import SocketioService from "@/services/socketio.service";

export default {
    mounted() {
        this.getShipping();
        this.detailsLoading = true;
    },
    created() {
        SocketioService.setupSocketConnection();
    },
    data() {
        return {
            loadingMsg: "Getting Shipping...",
            center: { lat: 6.465422, lng: 3.406448 },
            path: [],
            detailsLoading: false,
            shipping: {},
            shippingId: null,
            shippingDetails: {},
            tripId: null,
            polyOptions: {
                strokeColor: 'rgb(9,183,138)',
                strokeOpacity: 0.7,
                strokeWeight: 5
            },
            liveTripData: {},
            origin: { lat: 6.465422, lng: 3.406448 }
        }
    },
    computed: {
        getDriverETA() {
            const { origin, destination, driver, status } = this.liveTripData
            const destLat = status == 'accepted' ? origin?.lat : destination?.lat;
            const destLong = status == 'accepted' ? origin?.long : destination?.long;
            const driverLat = driver?.location?.latitude || 0;
            const driverLong = driver?.location?.longitude || 0;

            let Eta = this.getETA(driverLat, driverLong, destLat, destLong, 40)
            return Eta
        },
        polyLines() {
            return (this.path || []).map(([lat, lng]) => ({ lng, lat }));
        },
        destinationLabel() {
            switch (this.liveTripData.status) {
                case 'accepted':
                    return this.shipping?.shipperlocation?.contactName
                case 'in-transit':
                    return this.shipping?.consigneelocation?.contactPerson

                default:
                    return ''
            }
        },
    },
    watch: {
        center: {
            handler() {
                // Do not auto focus, manage map bounds manually
                this.updateMapBounds();
            },
            deep: true
        },
        shippingId(val) {
            // if (!this.canShowMap) return;
            this.socketEventName = val;
            this.interval = setInterval(() => {
                SocketioService.tripInfo(val).then((data) => {
                    if (data?.id) this.detailsLoading = false;
                    this.liveTripData = data;
                    const polyline = data.polyline || data?.info?.polyline || []
                    this.path = polyline;
                    this.center = { lat: polyline[0][0], lng: polyline[0][1] };
                    this.origin = { lat: polyline[0][0], lng: polyline[0][1] };
                    this.destination = { lat: polyline[polyline.length - 1][0], lng: polyline[polyline.length - 1][1] };
                    this.isLoading = false;
                });
            }, 1000);
        },
    },
    methods: {
        statusBg(val) {
            let bg = "";
            switch (val) {
                case "paid":
                    bg = "text-red-500";
                    break;

                case "pending":
                    bg = "text-primary-yellow";
                    break;

                case "in-transit":
                    bg = "text-primary-yellow";
                    break;

                case 'accepted':
                    bg = "text-teal-500";
                    break;
                case 'Picked_up':
                    bg = "text-teal-500";
                    break;

                default:
                    bg = "text-teal-500";
                    break;
            }
            return bg;
        },
        getRecipientNames() {
            return (this.shipping?.shipmentReceiever ?? [])
                .map(receiver => receiver?.location?.contactName)
                .filter(Boolean)
                .join(", ");
        },
        getLoadWeight() {
            return (this.shipping?.shipmentReceiever ?? []).reduce((total, receiver) => {
                const receiverWeight = (receiver?.packagees ?? []).reduce(
                    (sum, pkg) =>
                        sum +
                        (Number(pkg?.estimatedWeight ?? 0) *
                            Number(pkg?.quantity ?? 1)),
                    0
                );

                return total + receiverWeight;
            }, 0);
        },
        getTotalPackages() {
            return (this.shipping?.shipmentReceiever ?? []).reduce((total, receiver) => {
                const packageCount = (receiver?.packagees ?? []).reduce(
                    (sum, pkg) => sum + Number(pkg?.quantity ?? 1),
                    0
                );

                return total + packageCount;
            }, 0);
        },
        getPackageDescriptions() {
            return (this.shipping?.shipmentReceiever ?? [])
                .flatMap(receiver => receiver?.packagees ?? [])
                .map(pkg => pkg?.description)
                .filter(Boolean)
                .join(", ");
        },
        getETA(driverLat, driverLong, destLat, destLong, averageSpeedKmh) {
            if (
                driverLat == null || driverLong == null ||
                destLat == null || destLong == null
            ) {
                return null;
            }

            averageSpeedKmh = averageSpeedKmh || 40;

            const toRad = function (value) {
                return value * Math.PI / 180;
            };

            const R = 6371; // Earth radius in km
            const dLat = toRad(destLat - driverLat);
            const dLon = toRad(destLong - driverLong);
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(toRad(driverLat)) * Math.cos(toRad(destLat)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);

            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const distanceKm = R * c;

            const etaMinutes = Math.round((distanceKm / averageSpeedKmh) * 60);

            if (etaMinutes < 1) return "less than a minute";
            if (etaMinutes < 60) return etaMinutes + " min" + (etaMinutes > 1 ? "s" : "");

            const days = Math.floor(etaMinutes / (60 * 24));
            const hours = Math.floor((etaMinutes % (60 * 24)) / 60);
            const minutes = etaMinutes % 60;

            const parts = [];
            if (days > 0) parts.push(days + " day" + (days > 1 ? "s" : ""));
            if (hours > 0) parts.push(hours + " hour" + (hours > 1 ? "s" : ""));
            if (minutes > 0) parts.push(minutes + " min" + (minutes > 1 ? "s" : ""));

            return parts.join(" ");
        },
        async getShipping() {
            this.shipmentLoading = true;
            try {
                const response = await this.$_getCreatedNewBooking(this.$route?.params?.id);
                this.shipping = response.data.data.shipping;
                this.shippingId = this.idD2Tinterstate ? response.data.data?.firstMileShipment?.id : response.data.data?.shipping?.id;
                this.shippingDetails = response.data.data;
                this.tripId = this.idD2Tinterstate ? response.data.data?.firstMileShipment?.id : response.data.data?.shipping?.id;

                this.center = [
                    {
                        lat: this.shipping.shipperlocation?.address.lat || 0,
                        lng: this.shipping.shipperlocation?.address.lng || 0,
                    },
                    {
                        lat: this.shipping.consigneelocation?.address.lat || 0,
                        lng: this.shipping.consigneelocation?.address.lng || 0,
                    },
                ];
                this.loadingMsg = "Searching for a dispatcher...";
                console.log("shipping", this.shipping)

                if (
                    this.shipping.shippingMethod == "door-to-door"
                ) {
                    (await this.creatTripRequest());
                }
                if (this.shipping.tripId) {
                    this.load = true;
                    // this.isLoading = false;
                    // this.tripId = this.shipping.tripId
                }
            } catch (error) {
                //
            } finally {
                this.shipmentLoading = false;
            }
        },
        updateMapBounds() {
            if (this.map && this.center[0] && this.center[1]) {
                const bounds = new window.google.maps.LatLngBounds();
                bounds.extend(new window.google.maps.LatLng(this.center[0].lat, this.center[0].lng));
                bounds.extend(new window.google.maps.LatLng(this.center[1].lat, this.center[1].lng));
                this.map.fitBounds(bounds);
            }
        },
        registerSHippingSocket() {
            if (!this.canShowMap) return;
            this.socketEventName = this.$route?.params?.id;

            this.interval = setInterval(() => {
                SocketioService.tripInfo(this.socketEventName).then((data) => {
                    console.log("----data", data)
                    if (data) this.detailsLoading = false;
                    this.liveTripData = data;
                    const polyline = data.polyline || data?.info?.polyline || []
                    this.path = polyline;
                    this.center = { lat: polyline[0][0], lng: polyline[0][1] };
                    this.origin = { lat: polyline[0][0], lng: polyline[0][1] };
                    this.destination = { lat: polyline[polyline.length - 1][0], lng: polyline[polyline.length - 1][1] };
                    this.detailsLoading = false;
                });
            }, 1000);
        },
    },
    beforeDestroy() {
        SocketioService.disconnect();
        clearInterval(this.interval);
        this.$store.dispatch("resetState");
    },
}
</script>

<style lang="scss" scoped>
.loader {
    display: inline-block;
    width: auto;
    height: auto;
    animation: 2s infinite linear rolls;
    opacity: 0.5;
}

@keyframes rolls {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.confirmation_detail {
    @apply md:w-[48%] w-full
}

.detail_text {
    @apply flex pb-0 items-center;
}

.detail_item {
    @apply mt-2 pb-1 text-base;
}

.verical_divider {
    @apply w-[1px] bg-gray-400 h-[180px] block;
}

.terminal_container {
    @apply py-8
}
</style>